import React from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@finance/components/ui/popover";
import { Checkbox } from "@finance/components/ui/checkbox";
import { Button } from "@finance/components/ui/button";
import { Funnel, CaretDown } from "@phosphor-icons/react";

const slug = (s) => String(s).replace(/\s+/g, "-").toLowerCase();

// Excel-style multi-select checkbox filter.
// `selected` = [] means "no filter" (show all). OR logic across checked values.
export function MultiSelectFilter({ label, options, selected, onChange, testid, width = "w-56" }) {
  const allChecked = options.length > 0 && selected.length === options.length;
  const someChecked = selected.length > 0 && !allChecked;
  const activeCount = someChecked ? selected.length : 0;

  const toggle = (opt) => {
    if (selected.includes(opt)) onChange(selected.filter((x) => x !== opt));
    else onChange([...selected, opt]);
  };
  const toggleAll = () => onChange(allChecked ? [] : [...options]);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" className={`${width} justify-between font-normal`} data-testid={testid}>
          <span className="flex items-center gap-2 truncate">
            <Funnel size={15} className={activeCount ? "text-[#1B4383]" : "text-gray-400"} weight={activeCount ? "fill" : "regular"} />
            <span className="truncate">{label}</span>
            {activeCount > 0 && (
              <span className="rounded-full bg-[#1B4383] px-1.5 text-xs font-semibold text-white" data-testid={`${testid}-badge`}>{activeCount}</span>
            )}
          </span>
          <CaretDown size={14} className="shrink-0 text-gray-400" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="start" data-testid={`${testid}-panel`}>
        <label className="flex cursor-pointer items-center gap-2 border-b border-gray-100 px-3 py-2.5 hover:bg-gray-50" data-testid={`${testid}-select-all`}>
          <Checkbox checked={allChecked ? true : (someChecked ? "indeterminate" : false)} onCheckedChange={toggleAll} />
          <span className="text-sm font-medium">{allChecked ? "Clear all" : "Select all"}</span>
        </label>
        <div className="max-h-80 overflow-auto py-1">
          {options.map((o) => (
            <label key={o} className="flex cursor-pointer items-center gap-2 px-3 py-1.5 text-sm hover:bg-gray-50" data-testid={`${testid}-opt-${slug(o)}`}>
              <Checkbox checked={selected.includes(o)} onCheckedChange={() => toggle(o)} />
              <span className="truncate">{o}</span>
            </label>
          ))}
        </div>
        <div className="flex items-center justify-between border-t border-gray-100 px-3 py-2 text-xs text-gray-500">
          <button className="hover:text-[#1B4383]" onClick={() => onChange([])} data-testid={`${testid}-clear`}>Clear</button>
          <span>{selected.length === 0 ? "All" : `${selected.length} selected`}</span>
        </div>
      </PopoverContent>
    </Popover>
  );
}
